'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTimeOnPageTrigger = undefined;

var _executeClientTrigger = require('../../client-triggers/actions/executeClientTrigger');

var _timeOnPageTriggerDelaySeconds = require('../operators/timeOnPageTriggerDelaySeconds');

var _addTimeOnPageTriggerAction = require('./addTimeOnPageTriggerAction');

var _removeTimeOnPageTrigger = require('./removeTimeOnPageTrigger');

var addTimeOnPageTrigger = exports.addTimeOnPageTrigger = function addTimeOnPageTrigger(widgetData) {
  return function (dispatch) {
    dispatch((0, _removeTimeOnPageTrigger.removeTimeOnPageTrigger)());

    var delaySeconds = (0, _timeOnPageTriggerDelaySeconds.timeOnPageTriggerDelaySeconds)(widgetData);
    var delayMilliseconds = delaySeconds * 1000;

    var timeoutId = setTimeout(function () {
      dispatch((0, _executeClientTrigger.executeClientTrigger)());
    }, delayMilliseconds);

    dispatch((0, _addTimeOnPageTriggerAction.addTimeOnPageTriggerAction)(timeoutId));
  };
};